import { Button, Modal } from '@payaca/ambrosia';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { deleteTaxRate } from '@payaca/store/tax-rates/actions';
import { TaxRate } from '@payaca/types/taxRateTypes';
import { isNullish } from '@payaca/utilities/guards';
import { Nullish } from '@payaca/utilities/types';

import FeedbackBlock from '@payaca/components/feedbackBlock/FeedbackBlock';

import { FeedbackLevel } from '@payaca/types/feedbackTypes';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  taxRateId?: Nullish<TaxRate['id']>;
};

const DeleteTaxRateConfirmationModal: React.FC<Props> = ({
  isOpen,
  onClose,
  taxRateId,
}) => {
  const dispatch = useDispatch();

  const [isBusy, setIsBusy] = useState(false);
  const [deleteError, setDeleteError] = useState<Error | null>(null);

  const handleDelete = useCallback(() => {
    if (!isNullish(taxRateId)) {
      setIsBusy(true);
      dispatch(
        deleteTaxRate.request(taxRateId, (err) => {
          setIsBusy(false);
          if (err) {
            setDeleteError(err);
          } else {
            onClose();
          }
        })
      );
    }
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useCallback has a missing dependency: 'dispatch'
  }, [taxRateId, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={'Delete Tax Rate'}>
      <Modal.Body>
        <p className="delete-tax-rate-confirmation-modal__message">
          Are you sure you want to delete this tax rate?
        </p>
        {deleteError && (
          <FeedbackBlock
            isDismissable={true}
            onDismissed={() => setDeleteError(null)}
            feedbackLevel={FeedbackLevel.ERROR}
          >
            <span>{deleteError.message}</span>
          </FeedbackBlock>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button
            onClick={handleDelete}
            disabled={isBusy}
            variant={'outline'}
            colour={'red'}
          >
            Delete
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteTaxRateConfirmationModal;
